import { getAllTransferOrders, getAllWarehouseStock, getDispatchOrderByWarehouse, getDispatchOrderById, getFullfillmentOrderRows, getFullfillmentOrders, getTransferOrderById, getTransferOrderReferenceData, getTransferProducts, getWarehouseById, getWarehouseLocationsById, getWarehouseStockById, getWarehouses, getDispatchOrderReferenceData, getPickingListByDispatchOrder, getReceivingOrderByWarehouse, getReceivingOrderById, getDispatchOrderByPickingList, getCollectivePickingList, cancelDispatchOrderByPickingList, receiveProducts,  getShipmentLabelsBywarehouse, getRelocateProductsByWarehouse, getSearchStorageItem, stockCorrection, getAllProductsLocationsByWarehouse, getGetStorageItem, getDefaultReceivingStation, printProductLabel, printRelocationOrder, updateShipmentDispatchOrder, triggerSyncShipmentDispatchOrder, getInactiveDispatchOrderByWarehouse } from "src/utils/apiRequests";
import useResponse, { useResponseLegacy } from "../useResponse";
import useGetAllPaginatedItemsLegacy, { useGetAllPaginatedItems } from "../useGetAllPaginatedItems";

export const useGetWarehouseById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getWarehouseById, { id }, true);
    return response;
}
export const useGetWarehouseLocationsById = (id: string) => {
    const [response] = useResponseLegacy<any[]>(getWarehouseLocationsById, { id }, true);
    return response;
}
export const useGetWarehouseStockById = (id: string | string[]) => {
    return useGetAllPaginatedItemsLegacy<any>(getWarehouseStockById, 1000, "ArticleNumber", id);
};

export const useGetDispatchOrdersByWarehouse = (warehouseId: string | string[] | number | null | undefined, refreshKey?: unknown) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getDispatchOrderByWarehouse,
        pageSize: 500,
        idField: "DispatchOrderId",
        requestValues: warehouseId,
        refreshKey,
        shouldRequest: warehouseId != null,
    });
};

export const useGetInactiveDispatchOrdersByWarehouse = (warehouseId: string | string[] | number | null | undefined, refreshKey?: unknown, shouldRequest = true) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getInactiveDispatchOrderByWarehouse,
        pageSize: 500,
        idField: "DispatchOrderId",
        requestValues: warehouseId,
        refreshKey,
        shouldRequest: shouldRequest && warehouseId != null,
    });
};


export const useGetDispatchOrderByPickingList = ( pickingListid, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getDispatchOrderByPickingList, values:{ pickingListid,warehouseId }, requestNothingOnNull:true, logLevel:[]});
    console.log("response", response)
    return response;
}

export const useCancelDispatchOrderByPickingList = ( pickingListid, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:cancelDispatchOrderByPickingList, values:{ pickingListid,warehouseId }, requestNothingOnNull:true, logLevel:[]});
    console.log("response", response)
    return response;
}
export const useGetCollectivePickingList = ( pickingListIds: string, warehouseId: string | number) => {
    const {rows, loading, status} = useResponse<Blob>({requestFunction:getCollectivePickingList, values:{ pickingListIds,warehouseId }, requestNothingOnNull:true, dependency:[pickingListIds, warehouseId], logLevel:[], responseType:"blob"});
    console.log("response", rows)
    return {rows, loading, status};
}

export const useGetDispatchOrderByWarehouse = ( orderId, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getDispatchOrderById, values:{ orderId,warehouseId }, requestNothingOnNull:true, logLevel:[]});
    return response;
}
export const useGetShipmentLabelsByWarehouse = ( shipmentId, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getShipmentLabelsBywarehouse, values:{ shipmentId,warehouseId }, requestNothingOnNull:true});
    return response;
}

export const useTriggerSyncShipmentDispatchOrder = (shipmentId: number | string | null, warehouseId: string | number) => {
    return useResponse<void>({ requestFunction: triggerSyncShipmentDispatchOrder, values: { shipmentId, warehouseId }, requestNothingOnNull: true, dependency: [shipmentId, warehouseId],logLevel:["success"] });
};

export const useUpdateShipmentDispatchOrder = (shipmentId: number | string | null, warehouseId: string | number, data: any) => {
    return useResponse<any>({ requestFunction: updateShipmentDispatchOrder, values: { data, shipmentId, warehouseId }, requestNothingOnNull: true, dependency: [shipmentId, warehouseId, data] });
};
export const usePrintRelocationOrder = ( orderId, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:printRelocationOrder, values:{ warehouseId,orderId, }, dependency:orderId, requestNothingOnNull:true});
    return response;
}
export const useGetPickingListByDispatchOrder = (orderId:number|string|null, warehouseId:string|number) => {
    const {rows, loading, status} = useResponse<Blob>({requestFunction:getPickingListByDispatchOrder, values:{ orderId,warehouseId }, requestNothingOnNull:true, dependency:[orderId, warehouseId], responseType:"blob"});
    return {rows, loading, status};
  }

  export const useGetReceivingOrdersByWarehouse = (warehouseId: string | string[] | number, refreshKey?: unknown) => {
    const response = useGetAllPaginatedItems<any>({
        requestFunction:getReceivingOrderByWarehouse, 
        pageSize:500, idField:"ReceivingAdviceRowId",
         requestValues:warehouseId, 
         refreshKey,
         
         shouldRequest:!(warehouseId == null)
        });
        console.log(response)
    return response;
};
export const useGetDefaultReceivingStation = ( warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getDefaultReceivingStation, values:{ warehouseId }, dependency:warehouseId, requestNothingOnNull:true, logLevel:[]});
    return response;
}

export const usePrintProductLabel = ( productId: string | number) => {
    const response = useResponse<Blob>({requestFunction:printProductLabel, values:{ productId }, dependency:productId, requestNothingOnNull:true, logLevel:[],responseType:"blob"});
    return response;
}
export const useGetRelocateProductsByWarehouse = (warehouseId: string | string[] | number, refreshKey?: unknown) => {
    const response = useGetAllPaginatedItems<any>({
        requestFunction:getRelocateProductsByWarehouse, 
        pageSize:500, idField:"ProductId",
         requestValues:warehouseId, 
         refreshKey,
         
         shouldRequest:!(warehouseId == null)
        });
        console.log(response)
    return response;
};

export const useGetAllProductsLocationsByWarehouse = (warehouseId: string | string[] | number, refreshKey?: unknown) => {
    const response = useGetAllPaginatedItems<any>({
        requestFunction:getAllProductsLocationsByWarehouse, 
        pageSize:1000, idField:"WarehouseItemLocationId",
         requestValues:warehouseId, 
         refreshKey,
         
         shouldRequest:!(warehouseId == null)
        });
        console.log(response)
    return response;
};



export const useReceiveProducts = (payload: Parameters<typeof receiveProducts>[0] | null) => {
    const response = useResponse<any[]>({ requestFunction:receiveProducts, values: { payload }, dependency: payload, requestNothingOnNull: true, logLevel: ["success"] });
    console.log("response", response)
    return response;
};

export const useGetReceivingOrderByWarehouse = ( orderId, warehouseId: string | number) => {
    console.log("orderId, warehouseId", orderId, warehouseId);
    const response = useResponse<any[]>({requestFunction:getReceivingOrderById, values:{ orderId,warehouseId }, requestNothingOnNull:true});
    return response;
}

export const useSearchStorageItem = ( searchTerm, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getSearchStorageItem, values:{ searchTerm,warehouseId }, requestNothingOnNull:true});
    console.log("searchTerm, warehouseId", searchTerm, warehouseId);
    console.log("response", response)
    return response;
}
export const useGetStorageItem = ( productId,manufacturerProductId, warehouseId: string | number) => {
    const response = useResponse<any[]>({requestFunction:getGetStorageItem, values:{ productId,manufacturerProductId,warehouseId }, requestNothingOnNull:true});
    console.log("searchTerm, warehouseId", productId,manufacturerProductId, warehouseId);
    console.log("response", response)
    return response;
}
export const useStockCorrection = (warehouseId,payload: Parameters<typeof receiveProducts>[0] | null) => {
    const response = useResponse<any[]>({ requestFunction:stockCorrection, values: {warehouseId, payload }, dependency: payload, requestNothingOnNull: true });
    console.log("response", response)
    return response;
};



export const useGetAllWarehouseStock = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllWarehouseStock, 1000, "ArticleNumber");

}
export const useGetWarehouses = () => {
    const [response] = useResponseLegacy<any[]>(getWarehouses);
    return response;
}
export const useGetFullfillmentOrders = (shouldRequest = true) => {
    
    const response =  useGetAllPaginatedItemsLegacy<any[]>(getFullfillmentOrders, 1000, "Id", null, shouldRequest);
    return response;
}
export const useGetFullfillmentOrderRows = (id, dependency) => {
    
    const [response] = useResponseLegacy<any>(getFullfillmentOrderRows, { id }, true, dependency);
    return response;
}




export const useGetAllTransferOrders = () => {
    return useGetAllPaginatedItemsLegacy<any>(getAllTransferOrders, 500, "OrderId");

}
export const useLatestTransferOrders = (amount = 5) => {
    const {rows: result} = useResponse<any[]>({requestFunction:getAllTransferOrders,values:{amount,pageSize:1}, requestNothingOnNull:true});
    return result;
}
export const useGetTransferOrderById = (id: string, dependecy?) => {
    const [response] = useResponseLegacy<any>(getTransferOrderById, { id }, true,dependecy);
    return response;
}
export const useTransferOrderReferenceData = () => {
    return useResponseLegacy<any>(getTransferOrderReferenceData);
}

export const useDispatchOrderReferenceData = () => {
    const {rows,status} = useResponse<any>({requestFunction:getDispatchOrderReferenceData});
    
    return rows;
}

export const useGetTransferProducts = (warehouseId) => {
    const response =  useGetAllPaginatedItemsLegacy(getTransferProducts,500, "ProductId", warehouseId, !(warehouseId == null));
    return response;
}

